import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import { ISetType } from './interface';

function SetType(props: ISetType) {
  const { set, info, orientation } = props;
  function setType(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    set(value);
  }
  return (
    <Wrapper.Default flexDirection={orientation || 'row'} isActive>
      <Wrapper.Label>Tipo:</Wrapper.Label>
      <Form.Control
        as="select"
        style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
        value={info}
        onChange={(event) => setType(event)}>
        <option key={0} value="sintetico">
          {1} - Sintético
        </option>
        <option key={1} value="analitico">
          {2} - Análitico
        </option>
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetType;
